const dict = {
    statsList : {"S":"成功","F":"失败"}
}
export default dict